import { AUTH_TOKEN } from 'shared/constants/commmon';
import { detectAuthEnvironment } from 'shared/helpers/auth/detectAuthEnvironment';
import { sendToNative } from '../native/nativeBridge';

export type LogoutReason = '401' | 'user' | string;

export const logout = (reason: LogoutReason = 'user') => {
  try {
    localStorage.removeItem(AUTH_TOKEN);
  } catch {}

  const env = detectAuthEnvironment();

  if (env === 'native_webview') {
    // Нативка сама чистит SecureStore и покажет AuthScreen
    sendToNative({ type: 'LOGOUT', reason });
    return;
  }

  // browser / telegram
  try {
    document.location.reload();
  } catch {}
};
